import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Header from 'components/layouts/Header';
import Footer from 'components/layouts/Footer';
import Sidebar from 'components/layouts/Sidebar';

class App extends Component {
  render() {
    const { location } = this.props;

    return (
      <div className={'content ' + (location.type ? location.type : 'public')}>
        <Header key={this.props.location.pathname + 'header'} />
        <Sidebar />
        <main id="main">{this.props.children}</main>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  {}
)(withRouter(App));



// WEBPACK FOOTER //
// ./src/components/layouts/App.js